import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { consumePendingCourseId, getLoginPath } from '../auth/courseRedirect';

const EmailVerification = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const navigate = useNavigate();
    const [title, setTitle] = useState('E-posta onaylanıyor');
    const [message, setMessage] = useState('Lütfen bekleyin.');

    useEffect(() => {
        let redirectTimeout: ReturnType<typeof setTimeout> | undefined;
        const apiUrl = process.env.REACT_APP_API_BASE_URL + '/auth/email-verification';

        axios.post(apiUrl, { token })
            .then(() => {
                const courseId = consumePendingCourseId();
                setTitle('E-posta adresiniz onaylandı');
                setMessage(courseId
                    ? 'Giriş yaptıktan sonra kurs sayfanıza yönlendirileceksiniz.'
                    : 'Giriş sayfasına yönlendiriliyorsunuz.');
                redirectTimeout = setTimeout(() => {
                    navigate(courseId ? getLoginPath(courseId) : '/giris');
                }, 5000);
            })
            .catch(() => {
                setTitle('E-posta adresiniz onaylanamadı');
                setMessage('Doğrulama bağlantısı geçersiz veya süresi dolmuş olabilir.');
            });

        return () => {
            if (redirectTimeout) {
                clearTimeout(redirectTimeout);
            }
        };
    }, [navigate, token]);

    return (
        <section>
            <h2 className="auth-card-title">{title}</h2>
            <p className="auth-card-description">{message}</p>
        </section>
    );
};

export default EmailVerification;
